import React, { useEffect, useState } from "react";
import moment from "moment";
import { useSnakbar } from "../../../../../../Context/Context-Snakbar/ContextSnackbar";
import { invokeApi } from "../../../../../../bl_libs/invokeApi";
import { withRouter } from "react-router";
import { CircularProgress } from "@material-ui/core";
import NumberFormat from "react-number-format";
function BeforeAgreement(props) {
  const { showErrorSnak } = useSnakbar();

  const [isLoading, setIsLoading] = useState(false);
  const [inputs, setInputs] = useState({
    max_price: "",
    min_price: "",
    final_price: "",
  });
  const handleChange = (e) => {
    setInputs({
      ...inputs,
      [e.target.id]: e.target.value,
    });
  };

  const handleClick = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let requestObj = {
      path: "/api/foreman/add_recommended_price",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
      // recommended_price: `$${inputs.min_price} - $${inputs.max_price}`,
      final_price: `${inputs.final_price}`,
    };
    requestObj["postData"] = postData;

    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        document.getElementById("before-agreement-close").click();
        props.history.push(
          "/salesman/salesman-requests/sign-agreement/" +
            props.match.params.requestId
        );
      } else {
        showErrorSnak(res.message);
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <div
        className="modal fade"
        id="before-agreement"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="start-move-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="before-agreement-close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form
              onSubmit={handleClick}
              className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5"
            >
              <div className="modal-body p-0">
                <h5 className="text-center" id="start-move-title">
                  Add Info
                </h5>
                {/* <p className="pt-3 text-center">
                  Enter info before sign agreement
                </p> */}

                <div className="end-move-box">
                  <div className="row ">
                    <div className="col-12">
                      <div className="form-group">
                        <label
                          htmlFor="start-time"
                          className="overline dark-grey-color"
                        >
                          Enter Final Price
                        </label>

                        <NumberFormat
                          allowNegative={false}
                          disabled={isLoading}
                          allowLeadingZeros
                          required
                          value={inputs.final_price}
                          onChange={handleChange}
                          type="text"
                          className="form-control form-control-sm small-font-size"
                          id="final_price"
                          placeholder="Enter your final price"
                          autoComplete="off"
                        />
                        {/* <input
                          required
                          type="number"
                          id="final_price"
                          value={inputs.final_price}
                          onChange={handleChange}
                          placeholder="Enter Final price"
                          name=""
                          disabled={isLoading}
                          className="form-control form-control-sm small-font-size"
                        ></input> */}
                      </div>
                    </div>
                  </div>
                </div>

                {isLoading ? (
                  <div className="buttons-wrapper pt-2">
                    <div className="row pt-1 pb-3">
                      <div className="col-12 text-center">
                        <CircularProgress />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="buttons-wrapper pt-2">
                    <div className="row pt-1 pb-3">
                      <div className="col-12">
                        <button
                          type="submit"
                          className="custom-buton custom-buton-large w-100"
                        >
                          Go For Agreement
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(BeforeAgreement);
